var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconTheftProtection(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 35,
    viewBox: "0 0 27 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.195 13.837c-3.368 0-6.128 2.907-6.128 6.453 0 3.547 2.76 6.454 6.128 6.454 3.368 0 6.129-2.907 6.129-6.454 0-3.604-2.76-6.453-6.129-6.453zm.773 6.686v2.558h-1.546v-2.558a1.44 1.44 0 01-.497-1.046c0-.698.553-1.338 1.27-1.338.718 0 1.27.582 1.27 1.338 0 .406-.22.813-.497 1.046z",
    fill: "#F80032"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.165 2.384C16.729.524 14.41 0 13.14 0 10.6 0 8.613 1.337 7.62 3.78c-.442.987-.607 2.092-.607 3.255v9.767c.497-1.046 1.214-1.976 2.153-2.674V7.035c0-.523.055-1.047.22-1.57 1.05-4.884 6.792-3.663 8.78-3.081z",
    fill: "#F80032"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.281 6.22v7.849a7.656 7.656 0 012.154 2.675V6.802c-.442-.174-1.16-.465-2.154-.581z",
    fill: "#F80032"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.115 8.197a17.186 17.186 0 00-6.625-4.709c-.276-.116-.552-.233-.828-.29a19.103 19.103 0 00-4.472-.873c-2.927 0-3.92 2.093-4.197 2.965a15.132 15.132 0 013.258-.349c1.16 0 2.264.117 3.313.407l.662.175c.773.232 1.49.465 2.209.814.22.116.386.174.607.29 1.435.756 2.76 1.803 3.975 3.024v9.244c0 7.558-8.502 12.21-10.545 13.256-2.154-.989-10.987-5.582-10.987-13.372V9.65c1.159-1.28 2.54-2.268 3.975-3.023a9.571 9.571 0 01.662-3.082c0-.058.056-.058.056-.116A17.73 17.73 0 00.386 8.14L0 8.603V18.78c0 4.418 2.264 8.663 6.625 12.151 3.148 2.558 6.295 3.837 6.46 3.895l.442.175.442-.175c.11-.058 3.147-1.395 6.183-3.953 4.141-3.489 6.35-7.616 6.35-11.977V8.605l-.387-.408z",
    fill: "#F80032"
  })));
}

export default SvgIconTheftProtection;